import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import DialogueBody from "../../dialogue-body/DialogueBody";
const useStyles = makeStyles(({
  palette,
  typography
}) => {
  var _palette$dialogues$cu, _palette$dialogues, _palette$dialogues$cu2, _palette$dialogues$cu3, _palette$dialogues2, _palette$dialogues2$c, _palette$dialogues$cu4, _palette$dialogues3, _palette$dialogues3$c, _palette$dialogues$cu5, _palette$dialogues4, _palette$dialogues4$c;
  const background = (_palette$dialogues$cu = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$cu2 = _palette$dialogues.customer) === null || _palette$dialogues$cu2 === void 0 ? void 0 : _palette$dialogues$cu2.background) !== null && _palette$dialogues$cu !== void 0 ? _palette$dialogues$cu : palette.primary.light;
  const text = (_palette$dialogues$cu3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$c = _palette$dialogues2.customer) === null || _palette$dialogues2$c === void 0 ? void 0 : _palette$dialogues2$c.text) !== null && _palette$dialogues$cu3 !== void 0 ? _palette$dialogues$cu3 : palette.primary.dark;
  const borderRadius = (_palette$dialogues$cu4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$c = _palette$dialogues3.customer) === null || _palette$dialogues3$c === void 0 ? void 0 : _palette$dialogues3$c.borderRadius) !== null && _palette$dialogues$cu4 !== void 0 ? _palette$dialogues$cu4 : 12;
  const customerTextFont = (_palette$dialogues$cu5 = (_palette$dialogues4 = palette.dialogues) === null || _palette$dialogues4 === void 0 ? void 0 : (_palette$dialogues4$c = _palette$dialogues4.customer) === null || _palette$dialogues4$c === void 0 ? void 0 : _palette$dialogues4$c.fontFamily) !== null && _palette$dialogues$cu5 !== void 0 ? _palette$dialogues$cu5 : typography.fontFamily;
  return {
    primaryBackground: {
      backgroundColor: background
    },
    customerTextStyling: {
      color: text,
      fontFamily: customerTextFont,
      textAlign: "left"
    },
    customerDialouge: {
      display: "flex",
      position: "relative",
      borderRadius,
      padding: 16,
      flexDirection: "column",
      marginLeft: props => !props.isRtl && "auto",
      marginRight: props => props.isRtl && "auto",
      maxWidth: "75%",
      direction: props => props.isRtl ? "rtl" : "ltr"
    }
  };
});
const CustomerDialogueBody = ({
  body,
  isRtl
}) => {
  const classes = useStyles({
    isRtl
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.customerDialouge} ${classes.primaryBackground}`
  }, /*#__PURE__*/React.createElement(DialogueBody, {
    body: body,
    textStyling: classes.customerTextStyling,
    isRtl: isRtl
  }));
};
export default CustomerDialogueBody;
CustomerDialogueBody.propTypes = {
  body: PropTypes.string.isRequired,
  isRtl: PropTypes.bool.isRequired
};